// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteConfirmationPopupAction.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { compose, withProps, withHandlers } from 'recompose';
import { curry } from 'lodash/fp';
import ImportOverwriteTreeNode from 'logic/models/Izenda.ImportOverwriteTreeNode';
import { observable } from 'mobx';

function onClosing(props: any, overwriteOption: any, type: string) {
  type === 'accept' ? props.onAccept(overwriteOption) : props.onReject();
}

function convertToTree(overwriteInfo: any) {
  return observable([new ImportOverwriteTreeNode(overwriteInfo)]);
}

export default compose(
  withHandlers({
    onClosing: curry(onClosing)
  }),
  withProps(({ overwriteInfo }) => ({ overwriteOptionTree: convertToTree(overwriteInfo) }))
);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportOverwriteConfirmationPopupAction.js